export const langMap = {
  zh: 'zh-CN',
  en: 'en-US',
  jp: 'jp-JP',
  ru: 'ru-RU',
  es: 'es-ES',
  pt: 'pt-PT',
  fr: 'fr-FR',
  de: 'de-DE',
  tr: 'tr-TR',
  pl: 'pl-PL'
}

export const langI18nEn = [
  {
    code: 'en',
    file: 'en.js',
    iso: 'en',
    name: 'English'
  },
  {
    code: 'fr',
    file: 'fr.js',
    iso: 'fr',
    name: 'French'
  }
]

export const langI18nZh = [
  {
    code: 'zh',
    file: 'zh.js',
    iso: 'zh',
    name: 'Chinese'
  }
]

export const langRoute = ['zh', 'en', 'jp', 'ru', 'es', 'pt', 'fr', 'de', 'tr', 'pl']
